module.exports = __webpack_public_path__ + "static/media/CheckedCheckBox.31b7c32c.svg";